import paths from '@paths';
import {
  DashboardRoutes,
  MyPageRoutes,
  DisasterSettingsRoutes,
  DisasterNoticesRoutes,
  AdminRoutes,
  OptionsRoutes,
  UsersRoutes,
  SendRoutes,
  CsvRoutes,
} from '../Routes';
import common from './common';

const routing: AppRoute[] = [
  {path: paths.dashboard.main, exact: true, component: DashboardRoutes},
  {path: paths.myPage.main, exact: true, component: MyPageRoutes},
  {path: paths.myPage.edit, exact: true, component: MyPageRoutes},
  {path: paths.myPage.leave, exact: true, component: MyPageRoutes},
  {path: paths.myPage.card, exact: true, component: MyPageRoutes},
  {
    path: paths.disasterSettings.main,
    exact: true,
    component: DisasterSettingsRoutes,
  },
  {
    path: paths.disasterNotices.main,
    exact: true,
    component: DisasterNoticesRoutes,
  },
  {
    path: paths.disasterNotices.detail,
    exact: true,
    component: DisasterNoticesRoutes,
  },
  {
    path: paths.disasterNotices.answer,
    exact: false,
    component: DisasterNoticesRoutes,
  },
  {path: paths.admin.main, exact: true, component: AdminRoutes},
  {path: paths.admin.create, exact: true, component: AdminRoutes},
  {path: paths.admin.detail, exact: true, component: AdminRoutes},
  {path: paths.admin.edit, exact: true, component: AdminRoutes},
  {path: paths.users.main, component: UsersRoutes, exact: true},
  {path: paths.users.create, component: UsersRoutes, exact: true},
  {path: paths.users.detail, component: UsersRoutes, exact: false},
  {path: paths.users.edit, component: UsersRoutes, exact: false},

  {path: paths.options.confirm, exact: true, component: OptionsRoutes},
  {
    path: paths.send.main,
    exact: true,
    component: SendRoutes,
  },
  {
    path: paths.csv.main,
    exact: true,
    component: CsvRoutes,
  },

  ...common,
];

export default routing;
